import { useSuspenseQuery } from "@tanstack/react-query";
import { toolkitCollectionQueryOptions } from "@/app/tools/api/get-toolkit-collection";
import { useResourceScope } from "@/lib/resource-context";

export const useToolkitPickerData = () => {
  const scope = useResourceScope();
  return useSuspenseQuery(toolkitCollectionQueryOptions(scope));
};
